<template>
  <div class="page-add">
    <div class="add-title">试卷详情</div>
    <el-form
      size="small"
      class="form"
      label-position="right"
      label-width="100px"
      :model="paperForm"
      ref="paperForm"
    >
      <el-row>
        <el-col>
          <el-form-item label="试卷名称：" prop="paperName" required>
            <el-input
              v-model="paperForm.paperName"
              placeholder="请输入试卷名称"
              maxlength="50"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="试卷说明：" prop="paperDesc" required>
            <el-input
              type="textarea"
              v-model="paperForm.paperDesc"
              placeholder="请输入试卷说明"
              maxlength="200"
              autosize
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="form-select" label="试卷类型：" prop="paperType">
            <el-select
              v-model="paperForm.paperType"
              placeholder="请选择试卷类型"
              style="width:100%"
              disabled
            >
              <el-option
                v-for="item in paperTypeData"
                :key="parseInt(item.paramKey)"
                :label="item.paramValue"
                :value="parseInt(item.paramKey)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="分数配置：" required>
            <paper-score
              ref="paperScore"
              :questionTypeData="questionTypeData"
              :questionList="questionList"
              :paperType="String(paperForm.paperType)"
              :isFromDetail="true"
            ></paper-score>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row>
        <el-col class="m-b-12">
          <el-radio-group
            v-model="examQuestionType"
            size="small"
            class="radio-menu"
          >
            <el-radio-button
              class="radio"
              v-for="item in questionTypeData"
              :key="item.paramKey"
              :label="item.paramKey"
              >{{ item.paramValue }}</el-radio-button
            >
          </el-radio-group>
          <!--<el-form
            inline
            size="small"
            style="float: right"
            v-if="paperForm.paperType === 0"
          >
            <el-form-item>
              <el-checkbox
                v-model="dragaable"
                :disabled="dragDisabled"
                class="drag-box"
                style="padding-right:10px"
                >拖拽排序</el-checkbox
              >
            </el-form-item>
            <el-form-item>
              <butn
                title="批量移除"
                @click="deleteQuestions"
                style="margin-right:10px"
                :disabled="!batchEnable"
              ></butn>
            </el-form-item>
            <el-form-item>
              <butn
                btntype="primary"
                title="试题管理"
                @click="manageQuestions"
              ></butn>
            </el-form-item>
          </el-form>
          <butn
            v-else-if="paperForm.paperType === 1"
            class="import-question"
            btntype="primary"
            title="导入题库"
            @click="importQuestion"
          ></butn>
          <template v-else></template>-->
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="试题列表："
            ><exam-question-list
              v-if="paperForm.paperType === 0"
              ref="questionList"
              :examQuestionType="examQuestionType"
              :questionList="questionList"
              :draggable="dragaable"
              @sort="sort"
              :isFromDetail="true"
            ></exam-question-list>
            <exam-question-list-auto
              v-else
              :examQuestionType="examQuestionType"
              :questionList="questionList"
            ></exam-question-list-auto
          ></el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="form-handle">
      <!--<el-button size="small" @click="resetForm">重置</el-button>-->
      <el-button size="small" @click="goBack">返回</el-button>
      <!--<el-button size="small" type="primary" @click="submit">提交</el-button>-->
    </div>
  </div>
</template>

<script>
import PaperScore from "../add/paperScore";
import ExamQuestionList from "../add/examQuestionList";
import ExamQuestionListAuto from "../add/examQuestionListAuto";
import { getSysParamByTypes } from "@/api/sysParam";
import { Confirm } from "@/components/Confirm";
import vue from "@/main";
import { getExamPaperInfo } from "@/api/examPaper";
import { setItem } from "@/utils/storage.js";

export default {
  // 给子组件提供试题分类和试题类型(用function的方式提供响应式数据)
  provide() {
    return {
      getQuestionCategoryData: () => this.questionCategoryData,
      getQuestionTypeData: () => this.questionTypeData,
      getQuestionType: () => this.examQuestionType
    };
  },
  components: {
    PaperScore,
    ExamQuestionList,
    ExamQuestionListAuto,
  },
  data() {
    return {
      questionTypeData: [],
      questionCategoryData: [],
      paperTypeData: [],
      examQuestionType: "0",
      paperForm: {
        paperName: "",
        paperDesc: "",
        paperType: ""
      },
      dragaable: false,
      questionList: [],
      themeList: []
    };
  },
  created() {
    this.getExamInfo();
    vue.$on("deleteExamQuestion", async question => {
      const text = "确认移除该试题吗？";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        });
        this.questionList.splice(this.questionList.indexOf(question), 1);
      } catch (error) {
        if (error === "cancel") return;
      }
    });
    this.getSysParamByTypes(["EXAM_QUESTION_TYPE", "EXAM_QUESTION_CATEGORY", "PAPER_TYPE"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        this.questionTypeData = res.data["EXAM_QUESTION_TYPE"].sort(function(a, b) {
          return parseInt(a.paramKey) - parseInt(b.paramKey);
        });
        this.questionCategoryData = res.data["EXAM_QUESTION_CATEGORY"] || [];
        this.paperTypeData = res.data["PAPER_TYPE"] || [];
      });
    },
    getExamInfo() {
      getExamPaperInfo(this.$route.query.id).then(res => {
        if (!res || res.code != 0) return;
        this.paperForm.paperName = res.data.paperName;
        this.paperForm.paperDesc = res.data.paperDesc;
        this.paperForm.paperType = res.data.paperType;
        this.themeList = res.data.themeList;
        this.$refs["paperScore"].questionScore.splice(
          0,
          3,
          res.data.singleQstScore,
          res.data.multipleQstScore,
          res.data.judgeQstScore
        );
        if (this.paperForm.paperType === 1) {
          this.$refs["paperScore"].questionNum.splice(
            0,
            3,
            res.data.singleQstCount,
            res.data.multipleQstCount,
            res.data.judgeQstCount
          );
          this.$refs["paperScore"].totalScore.splice(
            0,
            3,
            res.data.singleQstCount * res.data.singleQstScore,
            res.data.multipleQstCount * res.data.multipleQstScore,
            res.data.judgeQstCount * res.data.judgeQstScore
          );
        }

        this.$nextTick(() => {
          this.questionList = res.data.examQuestionList;
          // this.$refs["questionList"].examQuestionType = "0";
        });
      });
    },
    // 试题管理
    manageQuestions() {
      vue.$emit("openQuestionList", this.questionList);
    },
    // 试题排序
    sort(arr, type) {
      // 筛选出不是当前类型的
      let newArr = this.questionList.filter(ele => {
        return ele.examQuestionType != type;
      });
      // 将筛选出来的和排序后的数组合并
      this.questionList = newArr.concat(arr);
    },
    goBack() {
      setItem(this.REFRESH_FLAG, true);
      setTimeout(() => {
        this.$router.push('/examPaper');
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
.m-b-12 {
  margin-bottom: 12px;
}
.radio-menu {
  margin-top: 10px;
  margin-left: 100px;
}
.dash-line {
  height: 0;
  border-bottom: 1px dashed #e8e8e8;
  margin: 10px 0;
}
.form-handle {
  text-align: center;
  margin-top: 20px;
}
.import-question {
  float: right;
  margin-top: 12px;
}
</style>
